import { BaseComponent } from '../../base-component';

type OpenableSheet = {
    open: boolean;
};

export class SustainabilityDetailsComponent extends BaseComponent {
    public rootSelector = '.js_pdp_sustainability-details';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        await this.addClickListenerForSheets();
    }

    private async addClickListenerForSheets() {
        const sustainabilitySheetLinks = this.getChildElements('[data-sustainability-details-sheet-id]');

        sustainabilitySheetLinks.forEach(elem => {
            elem.addEventListener('click', () => {
                const sheet = document.querySelector(`oc-sheet-v1#${elem.getAttribute('data-sustainability-details-sheet-id')}`);
                if (sheet) {
                    (sheet as unknown as OpenableSheet).open = true;
                }
            });
        });
    }
}
